module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    attrs: {
      "width": "100%;"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "27%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "70%"
    }
  }, [_c('p', {
    staticClass: "pre"
  }, [_vm._v("They laugh that win.")])])])])]), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%;"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "pre1"
  }, [_vm._v("—John Bartlett, "), _c('i', [_vm._v("Familiar Quotations")])])])]), _vm._v(" "), _c('tr', [_c('td', {
    staticStyle: {
      "width": "30%"
    }
  }), _vm._v(" "), _c('td', {
    staticStyle: {
      "width": "50%"
    }
  }, [_c('p', {
    staticClass: "pre2"
  }, [_vm._v("(attributed to W. Shakespeare)")])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-27645da5","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/fm.vue
// module id = 78
// module chunks = 0